module.exports = __webpack_public_path__ + "static/media/mobile-android-alt.929268ba.svg";